import { service } from '../index.js'

export const expressCompany = {
  // 获取快递公司列表
  list: (params) => {
    return service.get('/express-company/list', { params })
  },
  // 后台管理列表
  adminList: (params) => {
    return service.get('/express-company/admin/list', { params })
  },
  // 保存快递公司
  save: (data) => {
    return service.post('/express-company/admin/save', data)
  },
  // 切换状态
  toggleStatus: (data) => {
    return service.post('/express-company/admin/toggle-status', data)
  },
  // 删除快递公司
  delete: (params) => {
    return service.post('/express-company/admin/delete', params)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/express_company.js